import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { BlockTry } from "../../blocks/common-blocktry";
import { CommonConsult } from "../../blocks/common-consult";
import { CustomerBanner } from "../../blocks/customer-banner";
import { CustomerCompany } from "../../blocks/customer-company";
import { CustomerHot } from "../../blocks/customer-hot";
import { CustomerList } from "../../blocks/customer-list";
import { CustomerStorys } from "../../blocks/customer-storys";
import { HomeTryOn } from "../../blocks/home-try-on";
import { MainComment } from "../../blocks/main-comment";
import { MainLogo } from "../../blocks/main-logo";
import { SolutionCustomer } from "../../blocks/solution-customer";
import { Button } from "../../components/Button";
import { Footer } from "../../components/FooterV2";

import { Header } from "../../components/Header";
import { Notice } from "../../components/Notice";

import "./styles.less";

export const CustomerPage = () => {
  const { t } = useTranslation();
  return (
    <div className="customer-page">
      <Helmet>
        <title>
          SSO单点登录案例_统一身份认证客户案例_零信任网络案列-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode={"dark"} hasNotice />
      <CustomerBanner />
      {/* <CustomerList /> */}
      <CustomerHot />
      <MainComment />
      <CustomerCompany />
      <SolutionCustomer />
      <HomeTryOn />
      <Footer />
    </div>
  );
};
